
export default {
  prepareSequenceImages: Array(31)
  .fill('')
  .map((v, i) =>
    require(`../../../Box_sequences/00_TV_clean_box/TV_clean_box${i < 10 ? `0${i}` : i}.jpg`)
  ),
  designSliderImage: require('../../../product drawing/sixpackcarrier.png'),
  designImageList: [
    {
      number: 1,
      side: 'MIDDLE',
      image: require('../../../parts/sixpackcarrier/01.png'),
    },
    {
      number: '',
      image: require('../../../parts/sixpackcarrier/02.png'),
    },
    {
      number: 2,
      side:'JOINT'
,      image: require('../../../parts/sixpackcarrier/03.png'),
    },
    {
      number: 3,
      side:'BOTTOM',
      image: require('../../../parts/sixpackcarrier/04.png'),
    },
    {
      number: '',
      image: require('../../../parts/sixpackcarrier/05.png'),
    },
    {
      number: 4,
      side: 'MIDDLE2',
      image: require('../../../parts/sixpackcarrier/06.png'),
    },
    {
      number: '',
      image: require('../../../parts/sixpackcarrier/07.png'),
    },
    {
      number: 5,
      side:'SIDE',
      image: require('../../../parts/sixpackcarrier/08.png'),
    },
    {
      number: '',
      image: require('../../../parts/sixpackcarrier/09.png'),
    },
    {
      number: 6,
      side:'FRONT',
      image: require('../../../parts/sixpackcarrier/10.png'),
    },
    {
      number: '',
      image: require('../../../parts/sixpackcarrier/11.png'),
    },
  ],
  cutOutPartsImage: require('../../../parts/sixpackcarrier/12.png'),
  assembleSequenceImages: Array(106)
    .fill('')
    .map((v, i) =>
      require(`../../../sequences/36_sixpackcarrier/sixpackcarrier${
        i < 10 ? `0${i}` : i
      }.jpg`)
    ),
  completeImage: require('../../../complete/sixpackcarrier2.jpg'),
  completeImagePc: require('../../../complete/sixpackcarrier2.jpg'),
};




